import { render, staticRenderFns } from "./AddBankHolder.vue?vue&type=template&id=ce797f42&scoped=true&"
import script from "./AddBankHolder.vue?vue&type=script&lang=js&"
export * from "./AddBankHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce797f42",
  null
  
)

export default component.exports